import React, { useState, useRef, Fragment, useEffect, useContext } from "react";
import ReactPlayer from "react-player";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import screenfull from "screenfull";
import Controls from "./controller";
import Hls from "hls.js";
import { useHistory } from "react-router-dom";
import UAParser from 'ua-parser-js';
import { MyContext } from "../../PageRouters/layouts/publicLayout";


import {
  COUNTRYCODE,
  PARTNERID,
  UUID,
  CONTINUEWATCHING,
  HLSJSVERSION,
} from "../../utility/constants";

import DeviceDetector from '../DeviceDetector';
const useStyles = makeStyles((theme) => ({
  playerWrapper: {
    width: "100%",
    position: "relative",
  },

  controlsWrapper: {
    visibility: "hidden",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "98%",
    bottom: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  topControls: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
  },
  middleControls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  bottomWrapper: {
    display: "flex",
    flexDirection: "column",

    //background: "rgba(0,0,0,0.6)",
    //height: 60,
    padding: "10px",
  },

  bottomControls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    //height:40,
  },

  button: {
    margin: "5px",
  },
  controlIcons: {
    color: "#777",

    fontSize: 50,
    transform: "scale(0.9)",
    "&:hover": {
      color: "#fff",
      transform: "scale(1)",
    },
  },

  bottomIcons: {
    color: "#999",
    "&:hover": {
      color: "#fff",
    },
  },

  volumeSlider: {
    width: 100,
  },
}));

const format = (seconds) => {
  if (isNaN(seconds)) {
    return `00:00`;
  }
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = date.getUTCSeconds().toString().padStart(2, "0");
  if (hh) {
    return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
  }
  return `${mm}:${ss}`;
};

let count = 0;

function VideoPlayerComponent(props) {
  // console.log('props:::', props)
  //ima sdk client code start
  let adsManager;
  let adsLoader;
  let adDisplayContainer;
  //let playButton;
  let videoContent;
  let adsInitialized;
  let autoplayAllowed;
  let autoplayRequiresMuted;
  const google = window.google;

  const [adscomStatus, updateadscomStatus] = useState(false);
  //ima sdk client code end

  const history = useHistory();
  // alert("props" + JSON.stringify(props));
  let isAudioPoster = props.isAudioPoster && props.isAudioPoster !== null && props.isAudioPoster !== undefined && props.isAudioPoster !== "" ? props.isAudioPoster : ''
  const classes = useStyles();

  const [livecount, setLiveCount] = useState("");
  const [timeDisplayFormat, setTimeDisplayFormat] = React.useState("normal");
  const [showSpinner, setshowSpinner] = React.useState(true);
  //const [percentPlayed, setpercentPlayed] = React.useState(0);
  // let [captures, setcaptures] = React.useState([]);
  // const [playerdata, setplayerdata] = React.useState();
  // const [url, seturl] = useState('');
  const [showvolumeControl, setIsShowVolumeSlider] = useState(false);
  const [state, setState] = useState({
    checked: false,
    isAdsended: false,
    url: undefined,
    urlcookies: undefined,
    isAdsShowing: undefined,
    seekProcess: false,
    pip: false,
    fullScreen: false,
    playing: true,
    controls: false,
    light: false,
    subtitleDisplays: false,
    muted: false,
    played: 0,
    playedbackup: 0,
    duration: 0,
    playedsec: 0,
    timeDurationls: 0,
    playbackRate: 1.0,
    volume: 1,
    loop: false,
    seeking: false,
    hlsPlayerdata: {},
    videoaudiohas: [],
    framerate: [],
    episodes: [],
    recommend: [],
    mainsubtitledata: [],
    subtitleTracksdata: [],
    subtitleTracksSelected: "",
    currentaudioTrack: "",
    levellsmain: "",
    errorAlert: false,
    errorMessage: null,
  });
  // const [checked, setChecked] = useState(false);
  const [mileStone, setMilestone] = useState({
    m1: false,
    m2: false,
    m3: false,
    m4: false,
    m5: false,
  });
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [isMacOS, setIsMacOS] = useState(false);
  const playerRef = useRef(null);
  const playerContainerRef = useRef(null);
  const controlsRef = useRef(null);
  const {
    checked,
    isAdsended,
    url,
    urlcookies,
    isAdsShowing,
    playing,
    fullScreen,
    controls,
    light,
    muted,
    loop,
    playbackRate,
    pip,
    played,
    playedbackup,
    playedsec,
    volume,
    framerate,
    episodes,
    recommend,
    subtitleDisplays,
    videoaudiohas,
    currentaudioTrack,
    subtitleTracksdata,
    subtitleTracksSelected,
    levellsmain,
    seekProcess,
  } = state;
  const Device = DeviceDetector();


  const context = useContext(MyContext)


  useEffect(() => {
    setState({ ...state, fullScreen: context.fullscreen });
    //alert(context.fullscreen)
  }, [context.fullscreen])
  // console.log('props', props)
  useEffect(() => {
    const parser = new UAParser();
    const os = parser.getOS();
    // console.log('os', os)
    setIsMacOS(os.name === 'Mac OS');
    localStorage.setItem('isMac', os.name === 'Mac OS')
    const handleKeyDown = (e) => {
      debugger
      if (e.key === 'Escape') {
        console.log('Escape key pressed');
        setState((prevState) => ({ ...prevState, fullScreen: false }));
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    // Cleanup function
    return () => {
      //window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    // alert("000" + props.videoUrl)
    window.addEventListener("keydown", handleKeypress);
    if (props.setConfig) {
      if (props.adv_info !== undefined && props.adv_info !== null) {
        // let adsdownloadUrl = "?Key-Pair-Id=" + props.adv_info.aws["CloudFront-Key-Pair-Id"] + "&Policy=" + props.adv_info.aws["CloudFront-Policy"] + "&Signature=" + props.adv_info.aws["CloudFront-Signature"];
        let AdsUrl = props.adv_info;
        if (
          performance.navigation.type === performance.navigation.TYPE_RELOAD &&
          isAdsShowing === undefined
        ) {
          setState({ ...state, url: AdsUrl, isAdsShowing: true, muted: true });
        }
        if (props.medium === true && isAdsShowing === undefined) {
          setState({
            ...state,
            url: AdsUrl,
            isAdsShowing: true,
            muted: true,
            playing: true,
          });
        } else {
          //
          let userAgent = navigator.userAgent;
          let browserName;
          // alert('okay')
          if (isAdsShowing === undefined) {
            if (userAgent.match(/chrome|chromium|crios/i)) {
              browserName = "chrome";
              setState({ ...state, url: AdsUrl, isAdsShowing: true });
            } else if (userAgent.match(/firefox|fxios/i)) {
              browserName = "firefox";
              setState({
                ...state,
                url: AdsUrl,
                isAdsShowing: true,
                muted: true,

              });
            } else if (userAgent.match(/safari/i)) {
              browserName = "safari";
              setState({
                ...state,
                url: AdsUrl,
                isAdsShowing: true,
                muted: true,
              });
            } else if (userAgent.match(/opr\//i)) {
              browserName = "opera";
              setState({
                ...state,
                url: AdsUrl,
                isAdsShowing: true,
                muted: true,
              });
            } else if (userAgent.match(/edg/i)) {
              browserName = "edge";
              setState({
                ...state,
                url: AdsUrl,
                isAdsShowing: true,
                muted: false,
              });
            } else {
              browserName = "No browser detection";
            }
          } else {

          }
        }
      } else {

        let voddownloadUrl =
          "?Key-Pair-Id=" +
          props.aws["CloudFront-Key-Pair-Id"] +
          "&Policy=" +
          props.aws["CloudFront-Policy"] +
          "&Signature=" +
          props.aws["CloudFront-Signature"];
        let vodUrl = props.videoUrl;
        //page reload case

        if (
          performance.navigation.type === performance.navigation.TYPE_RELOAD
        ) {
          setState({
            ...state,
            url: vodUrl,
            urlcookies: voddownloadUrl,
            isAdsShowing: false,
            muted: false,
          });
        } else {
          let userAgent = navigator.userAgent;
          let browserName;

          if (userAgent.match(/chrome|chromium|crios/i)) {

            browserName = "chrome";
            setState({
              ...state,
              url: vodUrl,
              urlcookies: voddownloadUrl,
              isAdsShowing: false,
              muted: false,
              playing: true,
              playedsec: props.playedDuration,
              playedbackup: props.playedDuration
            });
          } else if (userAgent.match(/firefox|fxios/i)) {
            browserName = "firefox";
            setState({
              ...state,
              url: vodUrl,
              urlcookies: voddownloadUrl,
              isAdsShowing: false,
              muted: true,
              playing: true,
              playedsec: props.playedDuration,
              playedbackup: props.playedDuration
            });
          } else if (userAgent.match(/safari/i)) {
            browserName = "safari";
            setState({
              ...state,
              url: vodUrl,
              urlcookies: voddownloadUrl,
              isAdsShowing: false,
              muted: true,
              playing: true,
              playedsec: props.playedDuration,
              playedbackup: props.playedDuration
            });
          } else if (userAgent.match(/opr\//i)) {
            browserName = "opera";
            setState({
              ...state,
              url: vodUrl,
              urlcookies: voddownloadUrl,
              isAdsShowing: false,
              muted: true,
              playing: true,
              playedsec: props.playedDuration,
              playedbackup: props.playedDuration
            });
          } else if (userAgent.match(/edg/i)) {
            browserName = "edge";
            setState({
              ...state,
              url: vodUrl,
              urlcookies: voddownloadUrl,
              isAdsShowing: false,
              muted: false,
              playing: true,
              playedsec: props.playedDuration,
              playedbackup: props.playedDuration
            });
          } else {
            browserName = "No browser detection";
          }
        }
      }
      //window.onpopstate = (e) => handlepopstate(e);
      let lastUrl = window.location.href;
      new MutationObserver(() => {
        const url = window.location.href;
        if (url !== lastUrl) {
          let videoPercentPlayed = localStorage.getItem(
            "reactplayer.videoPercentPlayed"
          );
          handlepopstate(videoPercentPlayed);
          lastUrl = url;
        }
      }).observe(document, { subtree: true, childList: true });
    } else {
      //const socket =  socketIOClient(ENDPOINT)
      if (!props.setConfig) {
        let liveUrl = props.videoUrl;
        setState({ ...state, url: liveUrl, muted: false });

        // const socket = io("http://stg-api.planetcast.in:8086");

        // // client-side
        // socket.on("status", data => {
        //   console.log('mainData::',socket.id); // x8WIv7-mJelg7on_ALbx
        //   console.log('mainData::',socket.connected); // true
        //   console.log('count',data )
        //   setLiveCount(data.count);
        // });

        //
        // const ENDPOINT = "http://stg-api.planetcast.in:8086"
        // const socket = socketIOClient(ENDPOINT)
        // socket.on("status", data => {
        //   //console.log('liveplayer',data)
        //   setLiveCount(data.count);
        // });
      }
    }

    // if (context.isPopup) {
    //   setState({ ...state, playing: false });
    // }

    // if ((Device.isOs === "iOS" && Device.isType === "tablet") || (Device.isOs === "iOS" && Device.isType === "mobile") || (Device.isOs === "Mac OS" && Device.isType === "tablet") || (Device.isOs === "Mac OS" && Device.isType === "mobile")) {
    //   setState({ ...state, controls: true });
    // }

    return () => {

      window.removeEventListener("keydown", handleKeypress);
    };

  }, [subtitleTracksdata, props.adv_info, props.videoUrl, subtitleTracksdata, framerate, props.nextVod]);
  // React.useEffect(() => {
  //   window.addEventListener("keydown", handleKeypress);
  //   if (props.setConfig) {
  //     //window.onpopstate = (e) => handlepopstate(e);
  //     let lastUrl = window.location.href;
  //     new MutationObserver(() => {
  //       const url = window.location.href;
  //       if (url !== lastUrl) {
  //         let videoPercentPlayed = localStorage.getItem("reactplayer.videoPercentPlayed")
  //         handlepopstate(videoPercentPlayed);
  //         lastUrl = url;
  //       }
  //     }).observe(document, { subtree: true, childList: true });
  //   }

  //   if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
  //     setState({ ...state, muted: true, playing: true });
  //   } else {
  //     console.info("This page is not reloaded");
  //   }
  //   return () => {
  //     window.removeEventListener("keydown", handleKeypress);
  //   };

  // }, [subtitleTracksdata]);

  // const hlsPlayer = ()=>{
  //   let hlsPlayer =  playerRef.current.getInternalPlayer('hls')
  // }

  const handleKeypress = (event) => {
    //  console.log(event.keyCode)




    if (event.keyCode === 70) {
      screenfull.toggle(playerContainerRef.current);
    }

    if (event.keyCode === 27) {
      // screenful.toggle(playerContainerRef.current);
      //setState({ ...state, fullScreen: !state.fullScreen });
    }
  };

  const handlePlayPause = () => {

    setState({ ...state, playing: !state.playing });
    document.querySelector("#playercontainer_wrapper").classList.remove("show");

  };

  const handlepip = () => {
    setState({ ...state, pip: !state.pip });
  };

  const handleRewind = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10);
  };

  const handleFastForward = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10);
  };

  const handelstart = () => {
    controlsRef.current.style.visibility = "hidden";
    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let levels = hlsPlayer.levels;
    let levellsmain = hlsPlayer.currentLevel;
    let levelsreverse = levels;
    let currentaudioTrack = hlsPlayer.audioTrack;
    if (props.setConfig) {
      window._paq.push([
        "trackEvent",
        "Video Playback",
        "PLAYBACK_STARTED",
        props.tittle,
      ]);
    }
    // setState({ ...state, })
    setState({
      ...state,
      subtitleTracksdata: hlsPlayer.subtitleTracks,
      currentaudioTrack: currentaudioTrack,
      subtitleTracksSelected: hlsPlayer.subtitleTrack,
      framerate: levelsreverse,
      levellsmain: levellsmain,
    });
  };

  const handelReady = () => {
    // console.log('audio url', state.playing)
    if (props.isInnercard ?? false) {
      playerRef.current.seekTo(0);
      setState({ ...state, playing: true });
    } else {
      playerRef.current.seekTo(playedbackup)
    }

    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let levels = hlsPlayer.levels;
    let languagehas = hlsPlayer.audioTrackController.tracks;
    let levellsmain = hlsPlayer.currentLevel;
    let levelsreverse = levels;

    setState({
      ...state,
      videoaudiohas: languagehas,
      framerate: levelsreverse,
      levellsmain: levellsmain,
    });
  };

  const downloadUrl =
    "?Key-Pair-Id=" +
    props.aws["CloudFront-Key-Pair-Id"] +
    "&Policy=" +
    props.aws["CloudFront-Policy"] +
    "&Signature=" +
    props.aws["CloudFront-Signature"];

  const getContinueWatching = async (currentTimePlay) => {
    let formData = new FormData();
    formData.append("UUID", UUID);
    formData.append("countrycode", localStorage.getItem("countryCode"));
    formData.append("partnerid", PARTNERID);
    formData.append("tag", "insert");
    formData.append("duration", Math.floor(currentTimePlay));
    formData.append("entryid", props.entryid);
    await axios.post(CONTINUEWATCHING, formData, {
      headers: { token: localStorage.getItem("token") },
    });
  };
  const handleContinueWatchingEnded = async (e) => {
    var formData = new FormData();
    formData.append("partnerid", PARTNERID);
    formData.append("UUID", UUID);
    formData.append("tag", "delete");
    formData.append("entryid", props.entryid);

    await fetch(CONTINUEWATCHING, {
      method: "POST",
      headers: {
        token: localStorage.getItem("token"),

      },
      body: formData,
    }).then((response) => response.json());
  };

  const handelPercentplayed = (playedsec) => {
    let markers = [10, 25, 50, 75, 90];
    //let videoPercentPlayed = Math.floor((playedsec * 100) / duration);
    let videoPercentPlayed = parseFloat(playedsec / duration) * 100;
    localStorage.setItem(
      "reactplayer.videoPercentPlayed",
      Math.floor(videoPercentPlayed)
    );
    //setpercentPlayed(Math.floor(videoPercentPlayed));
    if (!localStorage.getItem("token")) {
      return false;
    }
    //console.log("Percentplayed",videoPercentPlayed,mileStone.m1)

    if (videoPercentPlayed > markers[0] && !mileStone.m1) {
      setMilestone({ ...mileStone, m1: true });
      // getContinueWatching(playedsec);
      //console.log(typeof videoPercentPlayed+"abhi",videoPercentPlayed,mileStone.m1)
    } else if (videoPercentPlayed > markers[1] && !mileStone.m2) {
      setMilestone({ ...mileStone, m2: true });
      // getContinueWatching(playedsec);
    } else if (videoPercentPlayed > markers[2] && !mileStone.m3) {
      setMilestone({ ...mileStone, m3: true });
      // getContinueWatching(playedsec);
    } else if (videoPercentPlayed > markers[3] && !mileStone.m4) {
      setMilestone({ ...mileStone, m4: true });
      // getContinueWatching(playedsec);
    } else if (videoPercentPlayed > markers[4] && !mileStone.m5) {
      setMilestone({ ...mileStone, m5: true });
      // getContinueWatching(playedsec);
    }
  };

  const handleProgress = (changeState) => {
    let playedsec = Math.floor(changeState.playedSeconds);
    if (
      (!changeState.played || changeState.played === 0) &&
      changeState.loaded > 0
    ) {
      setshowSpinner(false);
    }

    if (props.setConfig && !isAdsShowing) handelPercentplayed(playedsec);
    //handelPercentplayed(playedsec);
    if (count > 3) {
      controlsRef.current.style.visibility = "hidden";
      count = 0;
    }
    if (controlsRef.current.style.visibility === "visible") {
      count += 1;
    }
    if (!state.seeking) {
      setState({
        ...state,
        ...changeState,
        playedsec,
        playedbackup: playedsec
      });
      //console.log("playedsecst", playedsec)
    }
  };

  const handlepopstate = (percentPlayed) => {
    //console.log("reactplayer.videoPercentPlayed",percentPlayed)
    if (props.setConfig && percentPlayed) {
      //let percentPlayed = Math.floor(played * 100);
      let videoName = props.tittle;
      if (percentPlayed) {
        window._paq.push([
          "trackEvent",
          "Video Playback",
          "PLAYBACK_ABANDONED",
          videoName,
          percentPlayed,
        ]);

        if (percentPlayed > 25 && percentPlayed < 50) {
          window._paq.push([
            "trackEvent",
            "Video Playback",
            "PLAYBACK_WATCHED_25",
            videoName,
            percentPlayed,
          ]);
        } else if (percentPlayed > 50 && percentPlayed < 75) {
          window._paq.push([
            "trackEvent",
            "Video Playback",
            "PLAYBACK_WATCHED_50",
            videoName,
            percentPlayed,
          ]);
        } else if (percentPlayed > 75 && percentPlayed < 90) {
          window._paq.push([
            "trackEvent",
            "Video Playback",
            "PLAYBACK_WATCHED_75",
            videoName,
            percentPlayed,
          ]);
        } else if (percentPlayed > 90 && percentPlayed < 95) {
          window._paq.push([
            "trackEvent",
            "Video Playback",
            "PLAYBACK_WATCHED_90",
            videoName,
            percentPlayed,
          ]);
        } else if (percentPlayed > 95 && percentPlayed < 100) {
          window._paq.push([
            "trackEvent",
            "Video Playback",
            "PLAYBACK_WATCHED_95",
            videoName,
            percentPlayed,
          ]);
        }
      }
    }
  };

  const handleSeekChange = (e, newValue) => {
    setState({ ...state, played: parseFloat(newValue / 100), });
  };

  const handleSeekMouseDown = (e) => {
    setState({ ...state, seeking: true });
  };

  const handleSeekMouseUp = (e, newValue) => {
    //console.log("value", e)
    setState({ ...state, seeking: false });
    playerRef.current.seekTo(newValue / 100, "fraction");
  };

  const handleDuration = (duration) => {
    setState({ ...state, duration: duration });
  };

  const handleVolumeSeekDown = (e, newValue) => {
    setState({ ...state, seeking: false, volume: parseFloat(newValue / 100) });
  };
  const handleVolumeChange = (e, newValue) => {
    setState({
      ...state,
      volume: parseFloat(newValue / 100),
      muted: newValue === 0 ? true : false,
    });
  };
  const handelnextduration = () => {
    setState({
      ...state,
      playedbackup: 0,
      played: 0
    })
  }
  const handleEnded = (e) => {

    if (props.setConfig) {

      handelnextduration()
      props.nextEpisodePlay()
      setState({
        ...state,
        playing: true,
      })
      // if (
      //   props.aws !== undefined &&
      //   props.videoUrl !== undefined &&
      //   isAdsShowing !== false
      // ) {
      //   //
      //   let voddownloadUrl =
      //     "?Key-Pair-Id=" +
      //     props.aws["CloudFront-Key-Pair-Id"] +
      //     "&Policy=" +
      //     props.aws["CloudFront-Policy"] +
      //     "&Signature=" +
      //     props.aws["CloudFront-Signature"];
      //   let vodUrl = props.videoUrl;
      //   // alert(vodUrl);
      //   setState({
      //     ...state,
      //     url: props.videoUrl,
      //     isAdsShowing: false,
      //     isAdsended: true,
      //     playing: true,
      //     urlcookies: voddownloadUrl,
      //     isAdsended: true,
      //   });
      //   // setState({ ...state, url: props.videoUrl, urlcookies: voddownloadUrl, isAdsShowing: false, isAdsended: true })

      //   // return false;
      // }


      // if (
      //   props.nextVod !== null &&
      //   props.nextVod !== undefined &&
      //   props.nextVod !== {} &&
      //   isAdsShowing !== true
      // ) {
      //   //
      //   let name = props.nextVod.title;
      //   let namestring = name.replace(/\s+/g, "");
      //   let entryid = props.nextVod.entryid;
      //   let url = `/video/cat/${namestring.toLowerCase()}/${entryid}`;
      //   window.location.assign(url);
      // } else if (props.episodes.length > 0) {
      //   let firstData =
      //     props.episodes !== null &&
      //     props.episodes !== undefined &&
      //     props.episodes.length > 0 &&
      //     props.episodes[0].search_tag !== null &&
      //     props.episodes[0].search_tag !== undefined
      //       ? props.episodes[0].search_tag[0]
      //       : {};
      //   let name = firstData.name;
      //   let namestring = name.replace(/\s+/g, "");
      //   let entryid = firstData.entryid;
      //   let url = `/video/cat/${namestring.toLowerCase()}/${entryid}`;
      //   window.location.assign(url);
      //   //alert('data::'+JSON.stringify(url))
      // } else if (props.trailer.length > 0) {
      //   let firstData =
      //     props.trailer !== null &&
      //     props.trailer !== undefined &&
      //     props.trailer.length > 0 &&
      //     props.trailer[0] !== null &&
      //     props.trailer[0] !== undefined
      //       ? props.trailer[0]
      //       : {};
      //   let name = firstData.name;
      //   let namestring = name.replace(/\s+/g, "");
      //   let entryid = firstData.entryid;
      //   let url = `/video/cat/${namestring.toLowerCase()}/${entryid}`;
      //   window.location.assign(url);
      // } else {
      //   //alert(props.recommend.length)
      //   let firstData =
      //     props.recommend !== null &&
      //     props.recommend !== undefined &&
      //     props.recommend.length > 0 &&
      //     props.recommend[0] !== null &&
      //     props.recommend[0] !== undefined
      //       ? props.recommend[0]
      //       : {};
      //   let name = firstData.name;
      //   let namestring = name.replace(/\s+/g, "");
      //   let entryid = firstData.entryid;
      //   let url = `/video/cat/${namestring.toLowerCase()}/${entryid}`;
      //   window.location.assign(url);
      // }

      window._paq.push([
        "trackEvent",
        "Video Playback",
        "PLAYBACK_COMPLETED",
        props.tittle,
        100,
      ]);
    }
  };

  // const toggleFullScreen = () => {
  //   if (!fullScreen && isMacOS) {
  //     // setWindowSize({
  //     //   width: window.screen.width,
  //     //   height: window.screen.height,
  //     // });
  //     alert("mac os1"+ window.screen.width)
  //     if (playerContainerRef.current.requestFullscreen) {
  //       playerContainerRef.current.requestFullscreen();
  //     } else if (playerContainerRef.current.webkitRequestFullscreen) { /* Safari */
  //       playerContainerRef.current.webkitRequestFullscreen();
  //     } else if (playerContainerRef.current.msRequestFullscreen) { /* IE11 */
  //       playerContainerRef.current.msRequestFullscreen();
  //     }
  //     // console.log('Mac OS detected. Setting window size to full screen:', {
  //     //   width: window.screen.width,
  //     //   height: window.screen.height,
  //     // });
  //   }else{
  //     alert("non macos1")               
  //     if (playerContainerRef.current.requestFullscreen) {
  //       playerContainerRef.current.requestFullscreen();
  //     } else if (playerContainerRef.current.webkitRequestFullscreen) { /* Safari */
  //       playerContainerRef.current.webkitRequestFullscreen();
  //     } else if (playerContainerRef.current.msRequestFullscreen) { /* IE11 */
  //       playerContainerRef.current.msRequestFullscreen();
  //     }
  //     // screenfull.toggle(playerContainerRef.current);
  //     // setState({ ...state, fullScreen: !state.fullScreen });
  //   }
  // }

  const toggleFullScreen = () => {
    screenfull.toggle(playerContainerRef.current);
    setState({ ...state, fullScreen: !state.fullScreen });
  }

  const handleMouseMove = () => {
    controlsRef.current.style.visibility = "visible";
    setshowSpinner(false)
    count = 0;
  };

  const hanldeerror = (e, data) => {
    if (data && data?.fatal) {
      controlsRef.current.style.visibility = "visible";
      if (playedsec) {
        window._paq.push([
          "trackEvent",
          "Video Playback",
          "FATAL_PLAYER_ERROR",
          props.tittle,
          Math.floor(playedsec),
        ]);
        // alert("error" + JSON.stringify(e))
        setState({
          ...state,
          seekProcess: true,
        });
        setshowSpinner(true)
      }

      setState({
        ...state,
        errorAlert: true,
        errorMessage: data.details
      });

      let hls = playerRef.current.getInternalPlayer("hls");
      console.log("hlserrordetails", data.details)
      switch (data.type) {
        case Hls.ErrorTypes.NETWORK_ERROR:
          // try to recover network error
          console.log('fatal network error encountered, try to recover');
          hls.startLoad();
          break;
        case Hls.ErrorTypes.MEDIA_ERROR:
          console.log('fatal media error encountered, try to recover');
          hls.recoverMediaError();
          break;
        default:
          //cannot recover
          hls.destroy();
          break;
      }
    }
  };

  const handleplay = () => {
    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let subtitleTracks = hlsPlayer.subtitleTracks;
    let currentaudioTrack = hlsPlayer.audioTrack;
    let currentsubtitleTrack = hlsPlayer.subtitleTrack;
    setState({
      ...state,
      errorAlert: false,
      subtitleTracksdata: subtitleTracks,
      currentaudioTrack: currentaudioTrack,
      subtitleTracksSelected: currentsubtitleTrack,
    });
    setshowSpinner(false);
  };

  const hanldeMouseLeave = () => {
    state.errorAlert
      ? (controlsRef.current.style.visibility = "visible")
      : (controlsRef.current.style.visibility = "hidden");
    count = 0;
  };

  const handleDisplaysubtitle = (e) => {
    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let target = e.currentTarget;
    for (
      let i = 0;
      i < target.parentElement.parentElement.children.length;
      i++
    ) {
      target.parentElement.parentElement.children[i].classList.remove("active");
    }
    target.parentElement.classList.add("active");
    setState({ ...state, subtitleDisplays: !state.subtitleDisplays });
    // if (subtitleDisplays == true) {
    //   hlsPlayer.subtitleDisplay = true;
    //   hlsPlayer.subtitleTrack = 0;
    // } else {
    //   hlsPlayer.subtitleDisplay = false;
    //   hlsPlayer.subtitleTrack = -1;
    // }
    hlsPlayer.subtitleDisplay = false;
    hlsPlayer.subtitleTrack = -1;
  };

  const handleDisplayFormat = () => {
    setTimeDisplayFormat(
      timeDisplayFormat === "normal" ? "remaining" : "normal"
    );
  };

  const handlePause = (e) => {
    setState({ ...state, playing: false });
  };

  const handleBuffer = (e) => {
    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let subtitleTracks = hlsPlayer.subtitleTracks;
    let currentaudioTrack = hlsPlayer.audioTrack;
    let currentsubtitleTrack = hlsPlayer.subtitleTrack;

    setState({
      ...state,
      subtitleTracksdata: subtitleTracks,
      currentaudioTrack: currentaudioTrack,
      subtitleTracksSelected: currentsubtitleTrack,
    });
    if (seekProcess) {
      //seek 1 sec
      playerRef.current.seekTo(playerRef.current.getCurrentTime() + 1);
      setshowSpinner(false);
    }
  };

  const handleSeek = (e) => { };

  const handlePlaybackRate = (rate) => {
    setState({ ...state, playbackRate: rate });
  };

  const hanldeMute = () => {
    setState({ ...state, muted: !state.muted });
    setIsShowVolumeSlider(!showvolumeControl);
    setTimeout(() => {
      setIsShowVolumeSlider(false);
    }, 6000);
  };

  const handleEnablePIP = () => {
    //console.log('onEnablePIP')
    setState({ ...state, pip: true });
  };

  const handleDisablePIP = () => {
    //console.log('onDisablePIP')
    setState({ ...state, pip: false });
  };

  // //const currentTime = playerRef && playerRef.current ? playerRef.current.getCurrentTime() : "00:00";
  // const videoduration =
  //   playerRef && playerRef.current ? playerRef.current.getDuration() : "00:00";
  // const currentTime = playedsec;
  // const elapsedTime =
  //   timeDisplayFormat === "normal"
  //     ? format(currentTime)
  //     : `-${format(duration - currentTime)}`;
  // const totalDuration = format(videoduration);

  const currentTime =
    playerRef && playerRef.current
      ? playerRef.current.getCurrentTime()
      : "00:00";

  const duration =
    playerRef && playerRef.current ? playerRef.current.getDuration() : "00:00";
  const elapsedTime =
    timeDisplayFormat == "normal"
      ? format(currentTime)
      : `-${format(duration - currentTime)}`;

  const totalDuration = format(duration);

  const configlive = {
    //maxBufferLength : 300,
    file: {
      hlsOptions: {
        maxBufferLength: 300,
      },
      hlsVersion: HLSJSVERSION,
    },
  };

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  // console.log('isAudio', props.audioUrl)
  const config = {
    file: {
      forceHLS: !isSafari,
      forceVideo: !isSafari,
      attributes: {
        crossOrigin: "use-credentials",
      },

      hlsOptions: {
        forceHLS: !isSafari,
        // debug: true,
        xhrSetup: function (xhr, url) {

          if (props.aws !== undefined) {
            xhr.withCredentials = true; //send cookies
            xhr.credentials = "include";
            // if (props.isAudi)
            xhr.open("GET", url + downloadUrl); //get call params for video


            // xhr.setRequestHeader(
            //   "Access-Control-Allow-Headers",
            //   "Accept,Origin,Content-Type,X-LS-CORS-Template,X-LS-Auth-Token,X-LS-Auth-User-Token,Content-Type,X-LS-Sync-Result,X-LS-Sequence,token"
            // );
            xhr.setRequestHeader(
              "Access-Control-Allow-Methods",
              "POST, GET, OPTIONS, DELETE"
            );
            xhr.setRequestHeader("Access-Control-Allow-Credentials", "true");
            xhr.setRequestHeader("Access-Control-Allow-Origin", props.domUrl);
          }
        },
      },
      hlsVersion: HLSJSVERSION,
    },
  };

  // alert();
  // console.log('url::', url + downloadUrl)
  const checkConfig = () => {
    //
    if (props.setConfig === true) {
      if (isAdsShowing === true) {
        return {};
      } else {
        return config;
      }
    } else {
      return configlive;
    }
  };

  //ima sdk client code start
  const initDesktopAutoplayExample = () => {
    videoContent = playerRef.current.getInternalPlayer();
    //videoContent.play();
    //console.log("videoplayer",videoContent)
    //videoContent = document.getElementById('contentElement');
    //playButton = document.getElementById('playButton');
    // playButton.addEventListener('click', () => {
    //   // Initialize the container. Must be done via a user action where autoplay
    //   // is not allowed.
    //   adDisplayContainer.initialize();
    //   adsInitialized = true;
    //   videoContent.load();
    //   playAds();
    // });
    setUpIMA();
    // Check if autoplay is supported.
    checkAutoplaySupport();
    //console.log("ads_points",props.cue_ponits)
  }

  const checkAutoplaySupport = () => {
    // Test for autoplay support with our content player.
    var playPromise = videoContent.play();
    if (playPromise !== undefined) {
      playPromise.then(onAutoplayWithSoundSuccess).catch(onAutoplayWithSoundFail);
    }
  }

  const onAutoplayWithSoundSuccess = () => {
    // If we make it here, unmuted autoplay works.
    videoContent.pause();
    autoplayAllowed = true;
    autoplayRequiresMuted = false;
    autoplayChecksResolved();
  }

  const onAutoplayWithSoundFail = () => {
    // Unmuted autoplay failed. Now try muted autoplay.
    checkMutedAutoplaySupport();
  }

  const checkMutedAutoplaySupport = () => {
    videoContent.volume = 0;
    videoContent.muted = true;
    var playPromise = videoContent.play();
    if (playPromise !== undefined) {
      playPromise.then(onMutedAutoplaySuccess).catch(onMutedAutoplayFail);
    }
  }

  const onMutedAutoplaySuccess = () => {
    // If we make it here, muted autoplay works but unmuted autoplay does not.
    videoContent.pause();
    autoplayAllowed = true;
    autoplayRequiresMuted = true;
    autoplayChecksResolved();
  }

  const onMutedAutoplayFail = () => {
    // Both muted and unmuted autoplay failed. Fall back to click to play.
    videoContent.volume = 1;
    videoContent.muted = false;
    autoplayAllowed = false;
    autoplayRequiresMuted = false;
    autoplayChecksResolved();
  }

  const setUpIMA = () => {
    // Create the ad display container.
    createAdDisplayContainer();
    // Create ads loader.
    adsLoader = new google.ima.AdsLoader(adDisplayContainer);
    // Listen and respond to ads loaded and error events.
    adsLoader.addEventListener(
      google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
      onAdsManagerLoaded, false);
    adsLoader.addEventListener(
      google.ima.AdErrorEvent.Type.AD_ERROR, onAdError, false);

    // An event listener to tell the SDK that our content video
    // is completed so the SDK can play any post-roll ads.
    videoContent.onended = contentEndedListener;
  }

  const contentEndedListener = () => {
    videoContent.onended = null;
    if (adsLoader) {
      adsLoader.contentComplete();
    }
  }

  const autoplayChecksResolved = () => {
    // 
    //alert(props.imaAdsUrl)
    // Request video ads.
    var adsRequest = new google.ima.AdsRequest();
    adsRequest.adTagUrl = "https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpreonly&ciu_szs=300x250%2C728x90&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator="
    // adsRequest.adTagUrl = 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear&correlator=';
    // adsRequest.adTagUrl = 'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpremidpostpod&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&cmsid=496&vid=short_onecue&correlator=';
    // adsRequest.adTagUrl = props.imaAdsUrl
    // Specify the linear and nonlinear slot sizes. This helps the SDK to
    // select the correct creative if multiple are returned.
    adsRequest.linearAdSlotWidth = 640;
    adsRequest.linearAdSlotHeight = 400;

    adsRequest.nonLinearAdSlotWidth = 640;
    adsRequest.nonLinearAdSlotHeight = 150;

    adsRequest.setAdWillAutoPlay(autoplayAllowed);
    adsRequest.setAdWillPlayMuted(autoplayRequiresMuted);
    adsLoader.requestAds(adsRequest);
  }

  const createAdDisplayContainer = () => {
    // We assume the adContainer is the DOM id of the element that will house
    // the ads.
    adDisplayContainer = new google.ima.AdDisplayContainer(
      document.getElementById('adContainer'), videoContent);
  }

  const playAds = () => {
    try {
      if (!adsInitialized) {
        adDisplayContainer.initialize();
        adsInitialized = true;
      }
      // Initialize the ads manager. Ad rules playlist will start at this time.
      adsManager.init(640, 360, google.ima.ViewMode.NORMAL);
      // Call play to start showing the ad. Single video and overlay ads will
      // start at this time; the call will be ignored for ad rules.

      //Some browsers will allow video playback without user interactions if the video is muted. For this behavior, use and and call this method before AdsManager.start().
      //AdsRequest.setAdWillPlayMuted(true)
      adsManager.start();
    } catch (adError) {
      // An error may be thrown if there was a problem with the VAST response.
      videoContent.play();
    }
  }

  const onAdsManagerLoaded = (adsManagerLoadedEvent) => {
    // Get the ads manager.
    var adsRenderingSettings = new google.ima.AdsRenderingSettings();
    adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;
    // videoContent should be set to the content video element.
    adsManager =
      adsManagerLoadedEvent.getAdsManager(videoContent, adsRenderingSettings);
    // Mute the ad if doing muted autoplay.
    const adVolume = (autoplayAllowed && autoplayRequiresMuted) ? 0 : 1;
    adsManager.setVolume(adVolume);

    // Add listeners to the required events.
    adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, onAdError);
    adsManager.addEventListener(
      google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, onContentPauseRequested);
    adsManager.addEventListener(
      google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
      onContentResumeRequested);
    adsManager.addEventListener(
      google.ima.AdEvent.Type.ALL_ADS_COMPLETED, onAdEvent);

    // Listen to any additional events, if necessary.
    adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, onAdEvent);
    adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, onAdEvent);
    adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, onAdEvent);

    if (autoplayAllowed) {
      playAds();
    } else {
      //playButton.style.display = 'block';
    }
  }

  const onAdEvent = (adEvent) => {
    // Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
    // don't have ad object associated.
    var ad = adEvent.getAd();
    //console.log("adsData",ad)
    switch (adEvent.type) {
      case google.ima.AdEvent.Type.LOADED:
        // This is the first event sent for an ad - it is possible to
        // determine whether the ad is a video ad or an overlay.
        if (!ad.isLinear()) {
          videoContent.play();
        } else {
          //alert('adload')
          updateadscomStatus(true)
        }
        break;
      case google.ima.AdEvent.Type.COMPLETE:
        // This is the first event sent for an ad - it is possible to
        // determine whether the ad is a video ad or an overlay.
        if (!ad.isLinear()) {
          videoContent.play();
        } else {
          //alert('adfinish')
          updateadscomStatus(false)
        }
        break;
    }
  }

  const onAdError = (adErrorEvent) => {
    // Handle the error logging.
    // console.log("aderror", adErrorEvent.getError());
    //console.log("aderror",adErrorEvent.getErrorCode());

    adsManager.destroy();
    // Fall back to playing content.
    videoContent.play();
  }

  const onContentPauseRequested = () => {
    videoContent.pause();
    videoContent.onended = null;
  }

  const onContentResumeRequested = () => {
    //alert('jj')
    videoContent.play();
    videoContent.onended = contentEndedListener;
  }

  const handelToggleVisible = () => {
    controlsRef.current.classList.remove('visible')
  }

  //ima sdk client code end
  const handelChecked = (value) => {
    controlsRef.current.classList.add('visible')
    // 
    if (value === true) {
      // let hlsPlayer = playerRef.current.getInternalPlayer('hls')
      let audiourl = props.audioUrl
      let videourl = props.videoUrl
      setState({ ...state, checked: !state.checked, playing: !state.playing, url: props.audioUrl });

    } else {
      setState({ ...state, checked: !state.checked, url: props.videoUrl });

    }

  };

  const handelAudioReady = (value) => {
    playerRef.current.seekTo(playedbackup)
    setState({ ...state, playing: !state.playing, });
  }
  const handelAudiostart = () => {
    controlsRef.current.style.visibility = "visible";
  }
  const handleAudioplay = () => {
    setshowSpinner(false);
  };
  const handleAudioBuffer = (e) => {
    if (seekProcess) {
      //seek 1 sec
      playerRef.current.seekTo(playerRef.current.getCurrentTime() + 1);
      setshowSpinner(false);
    }
  };
  // console.log('state', state)
  return (
    <Fragment>

      {
        controls ? <div ref={playerContainerRef}
          className={`videoplayerwrapperContainer other player ${classes.playerWrapper} ${state.fullScreen === true ? "fullscreen" : ""
            }`}
          id="plyrBx"
        >

          <div id="adContainer" className={!adscomStatus && 'adshide'}></div>
          <ReactPlayer
            width={props.width}
            height={props.height}
            ref={playerRef}
            className={`videoplayerwrapper embed-responsive embed-responsive-16by9`}
            url={url}
            // url={"https://bitmovin-a.akamaihd.net/content/sintel/hls/playlist.m3u8"}
            pip={pip}
            playing={props.playeris === 'vod' ? context.isPopup ? false : playing : playing}
            controls={controls}
            light={light}
            loop={loop}
            playbackRate={playbackRate}
            volume={volume}
            muted={muted}
            onError={hanldeerror}
            onDuration={handleDuration}
            onPlay={handleplay}
            onProgress={handleProgress}
            onStart={handelstart}
            onReady={handelReady}
            onPause={handlePause}
            onBuffer={handleBuffer}
            onSeek={handleSeek}
            onEnded={handleEnded}
            onEnablePIP={handleEnablePIP}
            onDisablePIP={handleDisablePIP}
            // config={props.setConfig ? isAdsShowing === true ? {} : config : configlive}
            // config={isAdsShowing ? {} : props.setConfig ? config : configlive}
            config={props.playeris === 'vod' ? config : configlive}
          />

        </div> : <div
          onMouseMove={handleMouseMove}
          onMouseLeave={hanldeMouseLeave}
          ref={playerContainerRef}
          className={`videoplayerwrapperContainer vodplayer ${classes.playerWrapper} ${state.fullScreen === true ? "fullscreen" : ""
            }`}
          id="plyrBx"
        >

          {/* vod plyer */}
          <div id="adContainer" className={!adscomStatus && 'adshide'}></div>

          {/* audioplayer */}
          {
            checked && checked === true ? <ReactPlayer
              width={props.width}
              height={props.height}
              ref={playerRef}
              className={`videoplayerwrapper embed-responsive embed-responsive-16by9`}
              url={url}

              playing={props.playeris === 'vod' ? context.isPopup === true ? false : playing : playing}
              controls={controls}
              volume={volume}
              muted={muted}
              onReady={handelAudioReady}
              onError={hanldeerror}
              onDuration={handleDuration}
              onPlay={handleAudioplay}
              onProgress={handleProgress}
              onStart={handelAudiostart}
              onPause={handlePause}
              onBuffer={handleAudioBuffer}
              onSeek={handleSeek}
              onEnded={handleEnded}
              config={props.playeris === 'vod' ? config : configlive}
            /> : <ReactPlayer

              width={props.width}
              height={props.height}
              ref={playerRef}
              className={`videoplayerwrapper embed-responsive embed-responsive-16by9`}
              url={url}
              // url={'https://d29ij00yw17rar.cloudfront.net/shalomtv/content/s_o9nzfeg1/128.m3u8'}
              // url={props.videoUrl}
              // audioUrl={props.audioUrl}
              isAudio={props.isAudio}

              // url={"https://bitmovin-a.akamaihd.net/content/sintel/hls/playlist.m3u8"}
              pip={pip}
              playing={props.playeris === 'vod' ? context.isPopup === true ? false : playing : playing}
              controls={controls}
              light={light}
              loop={loop}
              playbackRate={playbackRate}
              volume={volume}
              muted={muted}
              onError={hanldeerror}
              onDuration={handleDuration}
              onPlay={handleplay}
              onProgress={handleProgress}
              onStart={handelstart}
              onReady={handelReady}
              onPause={handlePause}
              onBuffer={handleBuffer}
              onSeek={handleSeek}
              onEnded={handleEnded}
              onEnablePIP={handleEnablePIP}
              onDisablePIP={handleDisablePIP}
              // config={props.setConfig ? isAdsShowing === true ? {} : config : configlive}
              // config={isAdsShowing ? {} : props.setConfig ? config : configlive}

              // config={''}
              config={props.playeris === 'vod' ? config : configlive}
            />
          }
          {
            checked && checked === true ? <div className="audioPlayerImage" > <img src={isAudioPoster.size_1080_1920 ? isAudioPoster.size_1080_1920 : isAudioPoster.h_thumburl ? isAudioPoster.h_thumburl : isAudioPoster.v_thumburl ? isAudioPoster.v_thumburl : isAudioPoster.v_thumburl} width={'100%'} height={'100%'}
            /></div> : ''
          }

          <Controls
            nextEpisodePlay={props.nextEpisodePlay}
            handelChecked={handelChecked}
            handelToggleVisible={handelToggleVisible}
            checked={checked}
            isAudio={props.isAudio}
            catType={props.catType}
            hideSeekbar={props.hideSeekbar}
            handleClose={props.handleClose}
            nextVod={props.nextVod}
            tittle={props.tittle}
            currentaudioTrack={
              currentaudioTrack !== undefined ? currentaudioTrack : 0
            }
            showSpinner={showSpinner}
            setConfig={props.setConfig}
            levellsmain={levellsmain}
            ref={controlsRef}
            onPlayerRefrence={playerRef}
            onSeek={handleSeekChange}
            onSeekMouseDown={handleSeekMouseDown}
            onSeekMouseUp={handleSeekMouseUp}
            onRewind={handleRewind}
            onPlayPause={handlePlayPause}
            onFastForward={handleFastForward}
            playing={playing}
            fullScreen={fullScreen}
            tikcerdata={props.ticker}
            played={played}
            elapsedTime={elapsedTime}
            totalDuration={totalDuration}
            onError={(e) => hanldeerror(e)}
            onMute={hanldeMute}
            showvolumeControl={showvolumeControl}
            muted={muted}
            onVolumeChange={handleVolumeChange}
            onVolumeSeekDown={handleVolumeSeekDown}
            onChangeDispayFormat={handleDisplayFormat}
            playbackRate={playbackRate}
            onPlaybackRateChange={handlePlaybackRate}
            onToggleFullScreen={toggleFullScreen}
            handelnextduration={handelnextduration}
            volume={volume}
            onEnded={handleEnded}
            onPip={handlepip}
            languagedata={videoaudiohas}
            onsubtitleTracks={subtitleTracksdata}
            onFramerate={framerate}
            onsubtitleTracksdisplay={handleDisplaysubtitle}
            subtitleDisplays={subtitleDisplays}
            subtitleTracksSelected={subtitleTracksSelected}
            pip={pip}
            errorAlert={state.errorAlert}
            errorMessage={state.errorMessage}
            livecount={livecount}
            isAdsShowing={isAdsShowing}
            isPlayer={props.isPlayer}
            isMacOS={isMacOS}
          />
          {/* {console.log('isAudio', props.isAudio)} */}
        </div>
      }
    </Fragment >

  );
}
export default VideoPlayerComponent;
